export default __webpack_public_path__ + "img/b67ae66d64394721a2ba38c6ed4420c1.svg";